import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { activateAccount } from "./activate-account";

const initialState: ProcessingState = { processing: "idle" };

export const activateAccountReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(activateAccount.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(activateAccount.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(activateAccount.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
});
